<template>
  <div class="home">
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="router"></Header>
    <div class="areaArticle">
      <div ref="breadcrumb">
        <el-breadcrumb class="list" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item class="point" @click.native="jumpFrontier">前沿</el-breadcrumb-item>
          <el-breadcrumb-item v-if="tag !== ''">
            {{ tag }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class="container" :style="containerStyle">
        <el-col :span="15">
          <frontier-about-article ref="aboutArticle" :top="top" :tag="tag" :tag-info="tagInfo" @openDetail="openDetail" @jumpTag="jumpTag" @getTop="getTop"></frontier-about-article>
        </el-col>
        <el-col :span="9" class="containerRight">
          <frontier-right-page @jumpTag="jumpTag" @openDetail="openDetail"></frontier-right-page>
        </el-col>
      </el-row>
    </div>

    <!--联系专家-->
    <ContactExperts></ContactExperts>
    <!-- footer -->
    <Footer></Footer>
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
  import Header from './include/Header.vue';
  import Footer from './include/Footer.vue';
  import HussarForm from "./include/HussarForm";
  import ContactExperts from './include/ContactExperts.vue';
  import SideBar from "./include/SideBar";
  import FrontierAboutArticle from "./FrontierAboutArticle";
  import FrontierDetailsArticle from "./FrontierDetailsArticle";
  import FrontierRightPage from "./FrontierRightPage";
  import router from '@/router/index.js'
  let routerName = "";
  let tagData = "";
  export default {
    name: "FrontierSelectPage",
    data() {
      return {
        router:'/FrontierPage/FrontierSelectPage',
        headColor:"dark",
        isPageScroll: false,
        showForm: false,
        article:[],
        isFixed: false,
        id:0,
        articleHot: [],
        articleRead: [],
        articleRelevance: [],
        tagHot: [],
        tag:'', //选中的标签
        tagInfo: [],
        channelId: 291, //  291新闻动态  292行业资讯
        containerStyle: {paddingTop: '25px'}, //样式
        top: 160,
      };
    },
    components: {
      FrontierRightPage,
      FrontierDetailsArticle,
      FrontierAboutArticle,
      Header,
      HussarForm,
      Footer,
      SideBar,
      ContactExperts,
    },
    watch: {

    },
    methods: {
      jumpFrontier() {
        this.tag = ""
        this.$router.back()
      },
      jumpTag(item) {
        this.$nextTick(() => {
          this.$root.frontierTag = item;
          this.$router.push(`/FrontierPage/aboutArticle=${item.id}`);
          this.$refs['aboutArticle'].clickTag(item)
        })
      },
      openForm() {
        const self = this;
        self.showForm = true;
      },
      closeForm() {
        const self = this;
        self.showForm = false;
      },
      // 页面滚动
      handleNavScroll() {
        const self = this;
        self.isPageScroll = false;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 80) {
          self.isPageScroll = true;
        }
      },
      getTop() {
        this.top = this.$refs.breadcrumb.getBoundingClientRect().top
      },
      // 返回顶部
      backTop() {
        $('html ,body').animate({scrollTop: 0}, 700);
      },
      //打开详情
      openDetail(item) {
        this.$root.frontierArticle = item;
        this.$router.push(`/FrontierPage/detailsArticle=${item.id}`);
      },
    },
    mounted() {
      const self = this;
      const tagData = this.$root.frontierTag
      this.tag = tagData.name
      this.$refs['aboutArticle'].clickTag(tagData)
      window.addEventListener('scroll', self.handleNavScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleNavScroll)
    },
    created() {
      this.tagInfo = this.$root.frontierTag
      this.tag = this.$root.frontierTag.name;
    },
  }
</script>

<style scoped>
  /* 返回顶部 */
  .back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
  /* 前沿资讯 */
  .areaArticle {padding-bottom: 42px;width: 1200px;margin: auto;padding-top: 56px}
  .areaArticle .container .containerRight {padding-left: 80px;}
  .list {font-size: 14px;font-weight: 400;color: #A7A7A7;margin-top: 42px;}
  .list /deep/ .el-breadcrumb__item .el-breadcrumb__inner {color: #a7a7a7 !important;font-weight: 400;}
  .list /deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner {color: #0e0d0d !important;}
  .point {cursor: pointer}
</style>



// WEBPACK FOOTER //
// src/components/FrontierSelectPage.vue